import React, {useCallback, useState} from "react";
import {useErrorCallback, useToggle} from "hooks";
import {DataCollection} from "utils";
import {PrimaryMarketProject} from "api-client";
import {createProjectProvider} from "../../../../../../di";
import {Block, Pagination, ProjectsFilter, ProjectsHeader,} from "components";
import {Filter} from "components/pages/projects/filter/ProjectsFilter/ProjectsFilter";
import {defaultProjectsFilter} from "components/pages/projects/filter/ProjectsFilter/utils";
import ProjectsContextProvider, {ProjectsContextType} from "../ProjectsContext";
import PrimaryMarketOffer from "components/pages/projects/primary-market/PrimaryMarketOffer";
import './PrimaryMarket.scoped.scss';
import {ProjectsCount} from "../../../../../../api-client/models/project/ProjectsCount";
import apiClientConfig from "../../../../../../configs/app";
import CommonFilterIcon from "../../../../../../components/filters/CommonFilterIcon";
import {FilterIcon} from "../../../../../../components/filters/CommonFilterIcon/CommonFilterIcon";
import {DownloadSvg} from "../../../../../../components/svg";
import Modal from "../../../../../../components/common/modals/Modal";

export interface AutoInvestmentFilter {
  projectUuids?: Array<string>
}

const PrimaryMarket = () => {
  const handleError = useErrorCallback();
  const [loading, setLoading] = useState(false);
  const [projectsCount, setProjectsCount] = useState<ProjectsCount>({
    closed: 0,
    current: 0,
    fundRaising: 0,
    autoInvestment: 0,
    refunded: 0,
    overdue: 0,
  });
  const [projects, setProjects] =
        useState<DataCollection<PrimaryMarketProject>>(new DataCollection());
  const [filterActive, toggleFilter] = useToggle();
  const [favoritesActive, toggleFavorites] = useToggle();
  const [modalActive, setModalActive] = useState(false);

  const [filter, setFilter] = useState<Filter>(defaultProjectsFilter);

  const exportStatistics = async (): Promise<void> => {
    setLoading(true);
    try {
      const provider = await createProjectProvider();
      const response = await provider.exportPrimaryMarketStatistics(1, projects.totalCount, filter);
      window.location.assign(apiClientConfig.apiBaseUrl + response.url);
    } catch (err) {
      if (err instanceof Error) await handleError(err);
    } finally {
      setLoading(false);
    }
  };

  const value: ProjectsContextType = {
    filter,
    setFilter,
    filterActive,
    toggleFilter,
    favoritesActive,
    toggleFavorites
  };

  const loadData = useCallback(async (page: number, perPage: number): Promise<void> => {
    setLoading(true);
    try {
      const provider = await createProjectProvider();
      const projects = await provider.getPrimaryMarketProjects(page, perPage, filter);
      const dataCollection = new DataCollection<PrimaryMarketProject>();
      dataCollection.setCollection(projects);
      setProjects(dataCollection);
      const projectsCountResponse = await provider.getProjectsCount();
      setProjectsCount(projectsCountResponse);
    } catch (err) {
      if (err instanceof Error) await handleError(err);
    } finally {
      setLoading(false);
    }
  }, [filter]);

  const projectsList = useCallback(() => {
    return projects.items.map((item: PrimaryMarketProject) => {
      return <PrimaryMarketOffer project={item} key={item.uuid} setModalActive={setModalActive}/>;
    });
  }, [projects]);
  return (
    <Pagination
      onLoad={loadData}
      count={projects.count}
      totalCount={projects.totalCount}
      filterObject={filter}
      initialChangeFilter={(value: Partial<Filter>) => setFilter({...filter, ...value})}
    >
      <ProjectsContextProvider props={value}>
        <Block>
          <Block.Content>
            <Block.Header className="primary-market-block-header" withPadding>
              <ProjectsHeader projectsCount={projectsCount}/>
              <div onClick={exportStatistics} className="primary-market__download">
                <CommonFilterIcon type={FilterIcon.Download}>
                  <DownloadSvg/>
                </CommonFilterIcon>
              </div>
            </Block.Header>
            <Block.Body className="primary-market-block-body" withPadding={false}>
              <ProjectsFilter/>
              <Pagination.Content loading={loading}>
                <ul className="primary-market__list">
                  {projectsList()}
                </ul>
              </Pagination.Content>
            </Block.Body>
          </Block.Content>
        </Block>
        <Pagination.Paginator/>
      </ProjectsContextProvider>
      <Modal active={modalActive} onClose={() => setModalActive(false)}>
        <Modal.Close />
        <p className="primary-market__modal-conent">платежная история появится позже</p>
      </Modal>
    </Pagination>
  );
};

export default PrimaryMarket;